import Card from "react-bootstrap/Card"
import { BASE_SERVER_URL } from "../constants"
import EVENT_IMG_DEFAULT from "../img/event_card_default_img.svg"

/**
 * Article summary for front page. Contains a summary text and link to article.
 */
const EventCardImage = ({ imageSrc }) => {
    return (
        <Card.Img
            // TODO: convert to css classes
            style={{
                height: '100%',
                width: '100%',
                objectFit: 'cover',
                borderRadius: "5px",
                border: "1px solid black"
            }}
            src={imageSrc ?
                `${BASE_SERVER_URL}${imageSrc}`
                :
                EVENT_IMG_DEFAULT
            }
        />
    )
}


export default EventCardImage

